module.exports = __webpack_public_path__ + "img/icon-faq-07.b9c14126.png";